import * as yup from 'yup'

export const SingInSchema = yup.object().shape({
  email: yup
    .string()
    .email('Enter a valid email address')
    .required(
      'This field is required',
    ),
  password: yup
    .string()
    .required(
      'This field is required',
    )
})